<template>
	<div class="chat-events-bar" v-if="event">
		<transition name="chat-event">
			<div class="chat-event" :key="event.eventKey">
				<img v-if="event.serviceIconUrl" class="chat-event-icon chat-event-service" :src="event.serviceIconUrl" alt="">
				<img v-if="event.avatarUrl" class="chat-event-icon chat-event-avatar" :src="event.avatarUrl" alt="">
				<b class="chat-event-name">{{event.displayName}}</b>
				<span class="chat-event-text">{{event.eventString}}</span>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'ChatEventsBar',
	props: {
		// A prepared message (see util.prepareMessage), or null to hide the bar. Replacing it
		// slides the old one out the top while the new one comes up from the bottom.
		event: { type: Object, default: null },
	},
};
</script>

<style lang="scss">
.chat-events-bar {
	position: relative;
	flex: 0 0 auto;
	overflow: hidden;
	height: 1.7rem;
	margin: 0 .5rem;

	> .chat-event {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		gap: .35em;
		font-size: .85rem;
		white-space: nowrap;
		overflow: hidden;
		transition: transform .4s ease, opacity .4s ease;

		> .chat-event-icon {
			flex: 0 0 auto;
			width: 1.2rem;
			height: 1.2rem;
			object-fit: cover;
		}
		> .chat-event-avatar { border-radius: 50%; }
		> .chat-event-name, > .chat-event-text {
			overflow: hidden;
			text-overflow: ellipsis;
		}
		> .chat-event-text { opacity: .8; }
	}

	// New event rises into place from below, the one it replaces keeps going out the top.
	> .chat-event-enter { transform: translateY(100%); opacity: 0; }
	> .chat-event-leave-to { transform: translateY(-100%); opacity: 0; }
}
</style>
